module.exports = __webpack_public_path__ + "img/CapSensitivityDetailed-min.7a9452f5.png";